import { Study, StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

export const getLatestStudyDate = (studies: Study[]) => {
  const mainStudy = studies.find(
    (study) =>
      study.Type === StudyType.StudyType_CBCT ||
      study.Type === StudyType.StudyType_PanoramicXRay ||
      study.Type === StudyType.StudyType_IntraoralXRay,
  );

  if (mainStudy) {
    return (
      mainStudy.Time?.toDate().getTime() ??
      mainStudy.Created?.At?.toDate().getTime()
    );
  }

  const filteredStudies = studies.filter(
    (study) => study.Time || study.Created?.At,
  );

  if (filteredStudies.length > 0) {
    return Math.max(
      ...filteredStudies.map(
        (study) =>
          study.Created?.At?.toDate().getTime() ?? new Date().getTime(),
      ),
      0,
    );
  }

  return undefined;
};
